import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'

export const useStyles = makeStyles((theme) => ({
  slide: {
   /*  height: '100%', */
  },
  formTile: {
    color: theme.palette.secondary.main,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    marginBottom: '1.76vh',
    fontSize: 'clamp(1.625em, 3.625em, 3.6em)',
    [theme.breakpoints.down('xl')]: {
      fontSize: 'clamp(1.625em, 3.625em, 2.2em)',
    },
    textAlign: 'left',
  },
  formSubtitle: {
    color: theme.palette.dark,
    fontWeight: '500',
    fontSize: 'clamp(0.9em, 2em, 1.1em)',
    [theme.breakpoints.down('xl')]: {
      fontSize: 'clamp(0.9em, 2em, 1em)',
    },
    textAlign: 'left',
  },
  logo: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      width: '16vw !important',
    },
    [theme.breakpoints.down('md')]: {
      width: '22vw !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '45vw !important',
      marginTop: theme.spacing(8),
    },
  },
  share: {
    marginTop: theme.spacing(8),
    textAlign: 'left',
  },
  google: {
    textAlign: 'left',
    '& img': {
      maxWidth: '24px !important',
    },
  },
  btn: {
    textTransform: 'capitalize',
    width: '100%',
    height: '4.9vh',
    marginBottom: theme.spacing(2),
  },
  thankText: {
    color: theme.palette.other.white,
    fontWeight: 'bold',
    fontSize: 'clamp(1em, 2em, 1.75em)',
    textAlign: 'center',
  },
  staff: {
    borderRadius: '27px',
    boxShadow: '0px 30px 36px #0000003D',
    maxWidth: '100%',
  }
}))

export const RightColumn = styled(Grid)(({ theme, imagebg }) => ({
  backgroundImage: `url('${imagebg}'), linear-gradient(180deg, #000000, #000000)`,
  backgroundSize: 'cover',
  padding: theme.spacing(6),
  maxHeight: '87vh',
  display: 'flex',
  [theme.breakpoints.down('1024.05')]: {
    maxHeight: 'none'
  },
}))

export const LeftColumn = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xl')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  /* [theme.breakpoints.down('sm')]: { 
    height: '280px'
  } */
}))
